import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface PollOption {
  label: string;
  percentage: number;
}
interface PollQuestionProps {
  question: string;
  options: string[];
  results: PollOption[];
}
export function PollQuestion({
  question,
  options,
  results
}: PollQuestionProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  return <div className="space-y-4" data-id="element-66">
      <h3 className="text-lg font-semibold text-gray-900" data-id="element-67">{question}</h3>

      <div className="flex gap-3" data-id="element-68">
        {options.map(option => <button key={option} onClick={() => setSelectedOption(option)} className={`flex-1 px-4 py-3 rounded-full font-medium transition-all ${selectedOption === option ? 'bg-teal-500 text-white shadow-md' : 'bg-white border-2 border-gray-300 text-gray-700 hover:border-teal-400'}`} aria-pressed={selectedOption === option} data-id="element-69">
            {option}
          </button>)}
      </div>

      <AnimatePresence data-id="element-70">
        {selectedOption && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="space-y-3 pt-4" data-id="element-71">
            <p className="text-sm font-medium text-gray-600" data-id="element-72">Peer Results:</p>
            {results.map(result => <div key={result.label} className="space-y-1" data-id="element-73">
                <div className="flex justify-between text-sm" data-id="element-74">
                  <span className="text-gray-700" data-id="element-75">{result.label}</span>
                  <span className="font-semibold text-gray-900" data-id="element-76">
                    {result.percentage}%
                  </span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-77">
                  <motion.div className="h-full bg-teal-500" initial={{
              width: 0
            }} animate={{
              width: `${result.percentage}%`
            }} transition={{
              duration: 0.6,
              ease: 'easeOut',
              delay: 0.1
            }} data-id="element-78" />
                </div>
              </div>)}
          </motion.div>}
      </AnimatePresence>
    </div>;
}